import { ProductVariant } from '@shopify/hydrogen-react/storefront-api-types';
import React from 'react';
import { formatCurrency } from '../../common/formatCurrencies';

interface Props {
  data: ProductVariant;
}

const ProductPriceFormatted: React.FC<Props> = ({ data }) => {
  return (
    <div className="product-price">
      <div className="product-price-main">{formatCurrency(+data.price.amount)}</div>
      {data.compareAtPrice && (
        <div className="product-price-sale">{formatCurrency(+data.compareAtPrice.amount)}</div>
      )}
    </div>
  );
};

export default ProductPriceFormatted;
